export default "__VITE_ASSET__BsyK718U__"